import { Model } from 'survey-core';

/**
 * Choice questions store `value` (e.g. "Item 1") in `surveyModel.data`. For CSV download only,
 * resolve answers to visible text via SurveyJS `displayValue`. Does not mutate the model or DB data.
 *
 * @see https://surveyjs.io/form-library/documentation/handle-survey-results-access
 */
export const getSurveyDisplayData = (surveyModel: Model) => {
  const displayData = { ...surveyModel.data };

  surveyModel.getAllQuestions().forEach((question) => {
    if (!question.isEmpty()) {
      displayData[question.name] = question.displayValue;
    }
  });

  return displayData;
};
